import $api from "../http";
import {useHistory} from "react-router-dom";
import {useSnackbar} from "notistack";
import {isTestUserMode, isTestToken} from "../helpers/testUserHelper";

const useLogout = () => {
    const history = useHistory();

    const {enqueueSnackbar} = useSnackbar();

    return () => {
        const token = localStorage.getItem("token");
        
        // Проверяем режим тестового пользователя
        if (isTestUserMode() && token && isTestToken(token)) {
            console.log('%c[TEST MODE] Выход из тестового аккаунта', 'color: orange; font-weight: bold;');
            
            // Сохраняем данные, которые не должны удаляться при выходе
            const sessionToken = localStorage.getItem('session_token');
            const consentVersions = localStorage.getItem('consent_versions');
            const consentGrantedDate = localStorage.getItem('consent_granted_date');
            const availableConsentTypes = localStorage.getItem('available_consent_types');
            
            // Очищаем хранилища
            localStorage.clear();
            sessionStorage.clear();
            
            // Восстанавливаем сохраненные данные
            if (sessionToken) localStorage.setItem('session_token', sessionToken);
            if (consentVersions) localStorage.setItem('consent_versions', consentVersions);
            if (consentGrantedDate) localStorage.setItem('consent_granted_date', consentGrantedDate);
            if (availableConsentTypes) localStorage.setItem('available_consent_types', availableConsentTypes);
            
            enqueueSnackbar('Выход выполнен (тестовый режим)', {variant: "info"});
            history.push('/sign-in');
            window.location.reload();
            return;
        }
        
        // Обычный режим - запрос к backend
        const isEsiaLogout = (sessionStorage.getItem('isEsiaLogout') === 'true');
        $api.post(`auth-help/logOut`, {
            isEsiaLogout: isEsiaLogout,
            esiaRedirectUri: "https://lk2.doctor-arbitailo.ru/sign-in"
        })
            .then((responseData) => {
                if (responseData.status === 200) {
                    // Сохраняем данные, которые не должны удаляться при выходе
                    const sessionToken = localStorage.getItem('session_token');
                    const consentVersions = localStorage.getItem('consent_versions');
                    const consentGrantedDate = localStorage.getItem('consent_granted_date');
                    const availableConsentTypes = localStorage.getItem('available_consent_types');
                    
                    // Очищаем хранилища
                    localStorage.clear();
                    sessionStorage.clear();
                    
                    // Восстанавливаем сохраненные данные
                    if (sessionToken) localStorage.setItem('session_token', sessionToken);
                    if (consentVersions) localStorage.setItem('consent_versions', consentVersions);
                    if (consentGrantedDate) localStorage.setItem('consent_granted_date', consentGrantedDate);
                    if (availableConsentTypes) localStorage.setItem('available_consent_types', availableConsentTypes);

                    if (!isEsiaLogout) {
                        history.push('/sign-in');
                        window.location.reload();
                    } else {
                        window.location.href = responseData.data.response;
                    }
                }
            }).catch((error) => {
            enqueueSnackbar(error.response.data, {variant: "error"});
            console.error(error);
        });
    }
}

export default useLogout;